import * as _ from 'lodash'

import { BaseDto } from "./base.dto"

import { FileDto } from "./file.dto"
import { PagingDto } from "./paging.dto"
import { TranslationDto } from "./translation.dto"

export class FindMallServiceMenuDto extends PagingDto {
  mallId?: string
  searchText?: string
}

export class MallServiceMenuDto extends BaseDto {
  title?: TranslationDto
  image?: FileDto
  mobileImage?: FileDto
  mallId?: string
  enabled?: boolean
  link?: string
  v2Link?: string

  static create({ id, title, link, v2Link, mallId }: MallServiceMenuDto) {
    return _.assign(new MallServiceMenuDto(), {
      id: id || null,
      title: title || TranslationDto.create(),
      link: link || null,
      mallId: mallId || null,
      v2Link: v2Link || null
    })
  }
}

export class CreateMallServiceMenuDto {
  title?: TranslationDto
  imageId?: string
  mobileImageId?: string
  link?: string
  enabled?: boolean
  mallId?: string
  v2Link?: string
}